import { openOfflineDb, getVehiclesByIndex, getVehiclesByPrefix } from "./offlineDb";
import { chassisSuffix6, digitsOnly, lowerTrim, vehicleSuffix4 } from "./recordKeys";
import { sortFindVehicleItems } from "../pages/repo/vehicles/findVehiclesHelpers";

function toItems(rows) {
  return (rows || [])
    .map((row) => row?.payload)
    .filter((item) => item && (item._id || item.id));
}

export async function searchOfflineVehicles({
  dbName,
  query,
  mode,
  page = 1,
  limit = 100,
}) {
  if (!dbName) {
    return { items: [], total: 0, hasNext: false, missingLocal: true };
  }

  const db = await openOfflineDb(dbName);
  const kind = mode === "chassis" || mode === "chassisNumber" ? "chassis" : "vehicle";
  const trimmed = String(query || "").trim();
  let rows = [];

  if (kind === "chassis") {
    const suffix = chassisSuffix6(trimmed);
    if (suffix.length !== 6) {
      return { items: [], total: 0, hasNext: false, invalidSearch: true };
    }
    rows = await getVehiclesByIndex(db, "chassisSuffix6", suffix);
  } else if (mode === "loanAccountNumber") {
    rows = await getVehiclesByPrefix(db, "loanLower", lowerTrim(trimmed));
  } else if (mode === "customerName") {
    rows = await getVehiclesByPrefix(db, "customerNameLower", lowerTrim(trimmed));
  } else {
    const suffix = vehicleSuffix4(trimmed) || digitsOnly(trimmed);
    if (suffix.length !== 4) {
      return { items: [], total: 0, hasNext: false, invalidSearch: true };
    }
    rows = await getVehiclesByIndex(db, "vehicleSuffix4", suffix);
  }

  const sorted = sortFindVehicleItems(toItems(rows), kind);
  const safePage = Math.max(1, Number(page) || 1);
  const safeLimit = Math.max(1, Number(limit) || 100);
  const start = (safePage - 1) * safeLimit;
  const items = sorted.slice(start, start + safeLimit);

  return {
    success: true,
    items,
    total: sorted.length,
    page: safePage,
    limit: safeLimit,
    hasNext: start + items.length < sorted.length,
    source: "indexeddb",
  };
}

export async function getOfflineVehicleById(dbName, id) {
  if (!dbName || !id) return null;
  const db = await openOfflineDb(dbName);
  return new Promise((resolve, reject) => {
    const tx = db.transaction("vehicles", "readonly");
    const request = tx.objectStore("vehicles").get(String(id));
    request.onsuccess = () => resolve(request.result?.payload || null);
    request.onerror = () => reject(request.error);
  });
}
